<!-- @file 数据导出中心组件 -->
<template>
  <plv-dialog
    ref="dataExportCenter"
    v-model="dataExportCenterVisible"
    class="c-data-export-center"
    width="560px"
    @close="closeDialog"
  >
    <template slot="title">
      <span class="c-data-export-center__title">数据导出中心</span>
      <plv-tooltip content="导出记录有效期为7天">
        <plv-icon icon="info-circle" class="c-data-export-center__title-icon" />
      </plv-tooltip>
    </template>
    <section v-if="allExportedData.length">
      <ul ref="dataCenterList" class="c-data-export-center__list">
        <li
          v-for="(item, index) in allExportedData"
          :key="index"
        >
          <div class="c-data-export-center__item__file-info">
            <div class="c-data-export-center__item__file-info__left">
              <img src="./images/icon-file.svg" />
              <span>{{ item.filename || item.name }}</span>
            </div>
            <span v-if="item.fileSize" class="c-data-export-center__item__file-info__right">{{ item.fileSize | formatFileSize }}</span>
          </div>
          <div v-if="item.progress >= 0" class="c-data-export-center__item__progress-bar">
            <div :style="{width: item.progress * 100 + '%' }"></div>
          </div>
          <div class="c-data-export-center__item__status">
            <span class="c-data-export-center__item__status-build">{{ item.status | formatStatus }} <template v-if="(item.progress >= 0 && item.status !== 2)">{{ item.progress | formatProgress }}</template></span>
            <span v-if="item.status === 2" class="c-data-export-center__item__status-operate" @click="reBuild(item.id)">
              <plv-icon icon="refresh" /><span>重新生成</span>
            </span>
            <span v-if="item.status === 1" class="c-data-export-center__item__status-operate">
              <a :href="(item.downloadUrl || item.downPath) | formatDownloadUrl" download><plv-icon icon="down-load" /><span>下载到本地</span></a>
            </span>
          </div>
        </li>
      </ul>
    </section>
    <plv-empty v-else description="暂无导出记录" />
  </plv-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
  filters: {
    formatStatus(val) {
      let statusText = '';
      // status：-1-等待处理，0-处理中, 1-处理成功，2-处理失败，3-已取消
      switch (val) {
        // 等待处理，在页面显示为“正在生成”
        case -1: case 0:
          statusText = '正在生成';
          break;
        case 1:
          statusText = '已完成';
          break;
        case 2:
          statusText = '生成异常';
          break;
        default:
          break;
      }
      return statusText;
    },
    formatProgress(point) {
      return Number(point * 100) + '%';
    },
    formatFileSize(size) {
      const value = Number(size);
      if (size && !isNaN(value)) {
        const units = ['B', 'KB', 'MB', 'GB'];
        let index = 0;
        let k = value;
        if (value >= 1024) {
          while (k > 1024) {
            k = k / 1024;
            index++;
          }
        }
        return `${(k).toFixed(2)}${units[index]}`;
      }
    },
    formatDownloadUrl(url) {
      const urlArr = url.split(':');
      return `${location.protocol}${urlArr[1]}`;
    }
  },

  data() {
    return {
      pageNumber: 1
    };
  },

  computed: {
    ...mapState({
      firstBootTipVisible: state => state.dataExport.firstBootTipVisible,
      allExportedData: state => state.dataExport.allExportedData,
    }),
    dataExportCenterVisible: {
      get() {
        return this.$store.state.dataExport.dataExportCenterVisible;
      },
      set(val) {
        // val的值为 false
        this.$store.commit('dataExport/setDataExportCenterVisible', val);
      }
    }
  },

  mounted() {
    this.listenDialogScroll();
    this.getExportList();
  },

  methods: {
    closeDialog() {
      // 首次引导提示未显示过，做处理
      if (!this.firstBootTipVisible) {
        this.$store.commit('dataExport/setFirstBootTipVisible', true);
      }
      this.pageNumber = 1;
    },
    // 监听弹窗主体的滚动事件
    listenDialogScroll() {
      const _this = this;
      const dialogContainerBody = this.$refs.dataExportCenter.$el.querySelector('.plv-dialog__container__body__wrap');
      dialogContainerBody.addEventListener('scroll', function() {
        // 滚动到底部，获取数据
        if (this.clientHeight + this.scrollTop >= this.scrollHeight - 5 && _this.pageNumber < _this.totalPages) {
          _this.pageNumber += 1;
          _this.getExportList(_this.pageNumber, 10);
        }
      });
    },
    // 获取数据导出中心任务列表
    async getExportList(pageNumber = 1, pageSize = 10) {
      const res = await this.$store.dispatch('dataExport/getExportList', {
        pageNumber,
        pageSize
      });
      this.totalPages = res.totalPages;
      const allExportedData = this.allExportedData.concat(res.contents);
      this.$store.commit('dataExport/setAllExportedData', allExportedData);
    },
    async reBuild(id) {
      this.$store.commit('dataExport/setIsNeedPoll', false);
      await this.$store.dispatch('dataExport/reBuild', {
        id
      });
      setTimeout(() => {
        // 恢复轮询
        this.$store.commit('dataExport/setIsNeedPoll', true);
      }, 500);
    }
  }
};
</script>

  <style lang="scss">
  .c-data-export-center {
    z-index: 3000;
  }
  .c-data-export-center__title {
    margin-right: 9px;
  }
  .c-data-export-center__title-icon {
    font-size: 14px;
    color: #757575;
    cursor: pointer;
  }
  .c-data-export-center__list {
    padding: 0;
    > li {
      list-style: none;
      margin-bottom: 35px;
    }
  }
  .c-data-export-center__item__file-info {
    display: flex;
    justify-content: space-between;
    line-height: 22px;
  }
  .c-data-export-center__item__file-info__left {
    font-size: 16px;
    color: #333333;
    img {
      margin-right: 11.5px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }
  .c-data-export-center__item__file-info__right {
    font-size: 14px;
    color: #757575;
  }
  .c-data-export-center__item__progress-bar {
    width: 100%;
    height: 4px;
    background: #E8E8E8;
    border-radius: 6px;
    margin-top: 19px;
    margin-bottom: 8px;
    > div {
      height: 100%;
      background: #2196F3;
      border-radius: 6px;
    }
  }
  .c-data-export-center__item__status {
    display: flex;
    justify-content: space-between;
    line-height: 20px;
  }
  .c-data-export-center__item__status-build {
    font-size: 14px;
    color: #757575;
  }
  .c-data-export-center__item__status-operate {
    font-size: 14px;
    color: #2196F3;
    cursor: pointer;
    .plv-icon {
      font-size: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
    span {
      vertical-align: middle;
    }
  }
  </style>
